import { Button } from '@calendly/ui/components/button';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const headingSectionCss = "h1yj9h4v";
const HeadingSection = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headingSectionCss, props.className)} />;
});
const headerLayoutIsTabletUpCss = "h1qtv0t8";
const headerLayoutCss = "hgcxcir";
export const HeaderLayout = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(headerLayoutCss, {
    [headerLayoutIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const flexHeadingSectionIsPhoneCss = "f1a1ovld";
const flexHeadingSectionIsTabletUpCss = "f1k4x4a3";
const flexHeadingSectionCss = "fw00srl";
export const FlexHeadingSection = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  const isTabletUp = useDeviceType('isTabletUp');
  return <HeadingSection ref={ref} {...props} className={classNames(flexHeadingSectionCss, {
    [flexHeadingSectionIsPhoneCss]: isPhone,
    [flexHeadingSectionIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const headingSubSectionIsPhoneCss = "h1st9sp";
const headingSubSectionCss = "h1l0wmzj";
export const HeadingSubSection = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(headingSubSectionCss, {
    [headingSubSectionIsPhoneCss]: isPhone
  }, props.className)} />;
});
const headerImageIsPhoneCss = "huaj9z8";
const headerImageCss = "hcv5hxr";
export const HeaderImage = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(headerImageCss, {
    [headerImageIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const ListHeader = ({
  children
}) => <HeadingSection>
    <HeaderLayout>
      {children}
    </HeaderLayout>
  </HeadingSection>;
const listWrapperCss = "lohl2t";
export const ListWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(listWrapperCss, props.className)} />;
});
const listTitleWrapperIsPhoneCss = "l182dmpi";
const listTitleWrapperCss = "l1k4dz8r";
export const ListTitleWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(listTitleWrapperCss, {
    [listTitleWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const listTitleButtonIsTabletUpCss = "l1x33yrl";
const listTitleButtonCss = "l1ny81za";
export const ListTitleButton = forwardRef((props, ref) => {
  const isTabletUp = useDeviceType('isTabletUp');
  return <Button ref={ref} {...props} className={classNames(listTitleButtonCss, {
    [listTitleButtonIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});

require("./layout.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./layout.js");